import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DailyReport, DailyReportViewModel, MonthlyTotals, DailyReportResponse } from '@org/interfaces';

@Injectable({
  providedIn: 'root'
})
export class DailyReportService {
  private apiUrl = `${environment.apiUrl}/api/daily-reports`;

  constructor(private http: HttpClient) {}

  submitDailyReport(report: Partial<DailyReport>): Observable<DailyReport> {
    return this.http.post<DailyReport>(`${this.apiUrl}/submit`, report);
  }

  getDailyReport(tenantId: string, date: string): Observable<DailyReportResponse> {
    return this.http.get<DailyReportResponse>(`${this.apiUrl}/${tenantId}/${date}`);
  }
  getMonthlyReport(tenantId: string, year: number, month: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/monthly/${tenantId}/${year}/${month}`);
  }

  updateDailyReport(tenantId: string, date: string, report: Partial<DailyReport>): Observable<DailyReport> {
    return this.http.put<DailyReport>(`${this.apiUrl}/${tenantId}/${date}`, report);
  }
}